import script from "./HistoriaView.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoriaView.vue?vue&type=script&setup=true&lang=js"

import "./HistoriaView.vue?vue&type=style&index=0&id=02a26645&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a26645"]])

export default __exports__